import Empty from "@/components/empty.vue";
import Vue from 'vue';
import Component from 'vue-class-component';
@Component({
    components: {
        Empty,
    },
})
export class contentMixin extends Vue {
    data: any = {};
    ifPlay: boolean = false;
    playIndex: any = null;
    currentUtterance: SpeechSynthesisUtterance | null = null;
    keyboardHandler: ((e: KeyboardEvent) => void) | null = null;
    scrollToTop() {
        (this.$refs.templateContent as any).scrollToTop();
    }
    beforeDestroy() {
        // 确保在组件销毁时移除事件监听
        if (this.keyboardHandler) {
            window.removeEventListener("keydown", this.keyboardHandler);
        }
        // window.removeEventListener("beforeunload", this.handleBeforeUnload);
        this.stopAudio();
    }
    startPlayAudio() {
        this.$store.commit("updateIfCompose", false);
        this.ifPlay = true;
        this.playIndex = 0;
        // 添加键盘事件监听
        this.keyboardHandler = this.handleKeyboardInput.bind(this);
        window.addEventListener("keydown", this.keyboardHandler);
        // 需要清除所有题目的值
        let d: any = JSON.parse(JSON.stringify(this.data))
        d.data.forEach((item: any, idx: number) => {
            if (item.type == "计分单选") {
                this.$set(item, 'value', {});
            } else if (item.type == "单选") {
                this.$set(item, 'value', "");
            }
        });
        this.data = d;
        this.$forceUpdate();
        this.playAudio(0);
        // 页面滚动到最上面
        const parent = (document as any).getElementById("liangbiao-detail");
        parent.scrollTop = 0;
    }
    stopPlayAudio() {
        this.ifPlay = false;
        this.$store.commit("updateIfCompose", true);
        this.playIndex = null;
        // 移除键盘事件监听
        if (this.keyboardHandler) {
            window.removeEventListener("keydown", this.keyboardHandler);
            this.keyboardHandler = null;
        }
        this.stopAudio();
    }
    async playAudio(index: any) {
        if (
            (this.data.data[index].type != "单选" &&
                this.data.data[index].type != "计分单选") ||
            this.data.data[index].hide
        ) {
            this.playAudio(index + 1);
            return;
        } else {
            this.playIndex = index;
            // 这里需要判断下，如果下一题不在可视区域，则滚动到下一题
            const nextQuestion = document.getElementById(`liangbiao${index}`);
            if (nextQuestion) {
                const parent = (document as any).getElementById("liangbiao-detail");
                // 获取parent的高度
                const parentHeight = parent.offsetHeight;
                // 获取nextQuestion的高度
                const nextQuestionHeight = nextQuestion.offsetHeight;
                // 如果nextQuestion不在可视区域，则滚动到下一题
                if (
                    nextQuestion.offsetTop + nextQuestionHeight >
                    parentHeight + parent.offsetTop + parent.scrollTop
                ) {
                    parent.scrollTop =
                        nextQuestion.offsetTop +
                        nextQuestionHeight -
                        parentHeight -
                        parent.offsetTop;
                }
            }
        }
        //前端语音读题,把文字生成语音读出来
        const text = this.data.data[index].title;
        await this.playCountdown(text);
    }
    stopAudio() {
        if (this.currentUtterance) {
            this.currentUtterance.onend = null;
            this.currentUtterance = null;
        }
        window.speechSynthesis.cancel();
    }
    playCountdown(val: any): Promise<void> {
        return new Promise((resolve) => {
            this.stopAudio();

            // 其他题目编辑状态改为false,当前题目编辑状态改为true
            this.data.data.forEach((item: any, index: any) => {
                item.edit = index == this.playIndex;
            });
            const text = val;
            const utterance = new SpeechSynthesisUtterance(text);
            this.currentUtterance = utterance;

            // 设置中文语音
            const voices = window.speechSynthesis.getVoices();
            const chineseVoice = voices.find((voice) => voice.lang.startsWith("zh"));
            if (chineseVoice) {
                utterance.voice = chineseVoice;
            }

            utterance.onend = () => {
                this.currentUtterance = null;
                resolve();
            };

            window.speechSynthesis.speak(utterance);
        });
    }
    handleKeyboardInput(e: KeyboardEvent) {
        if (!this.ifPlay || this.playIndex === null) return;

        const currentQuestion = this.data.data[this.playIndex];
        if (!currentQuestion || !currentQuestion.options) return;

        // 只处理数字键
        const key = parseInt(e.key);
        if (isNaN(key)) return;

        // 检查选项是否存在
        if (key > 0 && key <= currentQuestion.options.length) {
            // 单选直接设置值
            const option = currentQuestion.options[key - 1];
            if (currentQuestion.type == "计分单选") {
                this.radioScoreClick(option, key - 1, this.playIndex);
            } else if (currentQuestion.type == "单选") {
                this.radioClick(option, this.playIndex);
            }
        }
    }
    radioScoreClick(option: any, optionIndex: any, tIndex: any) {
        const ifCompose = this.$store.state.ifCompose;
        if (!ifCompose && !this.data.data[tIndex].edit) {
            return;
        }
        if (
            this.data.data[tIndex].value &&
            this.data.data[tIndex].value.name &&
            this.data.data[tIndex].value.name === option.name
        ) {
            this.data.data[tIndex].value = {};
        } else {
            this.data.data[tIndex].value = option;
        }
        this.$forceUpdate();
        this.selectChange(tIndex);
    }
    radioClick(ev: any, tIndex: any) {
        const ifCompose = this.$store.state.ifCompose;
        if (!ifCompose && !this.data.data[tIndex].edit) {
            return;
        }
        const d: any = JSON.parse(JSON.stringify(this.data))
        d.data[tIndex].value === ev
            ? (d.data[tIndex].value = "")
            : (d.data[tIndex].value = ev);
        this.data = d;
        this.$forceUpdate();
        this.selectChange(tIndex);

    }
    // 单选、计分单选值改变
    selectChange(tIndex: any) {
        if (this.ifPlay) {
            // 如果是最后一题，则不需要切换到下一题
            // 后面的题目没有hide==false或者type==段落标题或者type==主标题都算作当前题目为最后一题
            let isLast = true;
            if (tIndex == this.data.data.length - 1) {
                isLast = true;
            } else {
                for (let i = tIndex + 1; i < this.data.data.length; i++) {
                    if (
                        !this.data.data[i].hide &&
                        (this.data.data[i].type == "单选" ||
                            this.data.data[i].type == "计分单选")
                    ) {
                        isLast = false;
                        break;
                    }
                }
            }
            if (isLast) {
                this.stopPlayAudio();
            } else {
                this.playAudio(tIndex + 1);
            }
        }
    }
}